if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
        constructor() {
            super();
            this.isUpdating = false;
        }

        connectedCallback() {
            this.initCart();
            PubSub.subscribe('cart-updated', this.openCart.bind(this));
            PubSub.subscribe('cart-updated', this.updateCart.bind(this));
        }

        initCart() {
            this.productRemove = this.querySelectorAll('.cart_line_item-remove');
            this.productQty = this.querySelectorAll('.cart_line_item-qty__update');

            const closeBtn = this.querySelector('.cart-drawer-close');
            const closeDrawerBtn = this.querySelector('.close_cart_drawer');

            if (closeBtn && !closeBtn.dataset.listenerAdded) {
                closeBtn.addEventListener('click', this.closeCart.bind(this));
                closeBtn.dataset.listenerAdded = 'true';
            }

            if (closeDrawerBtn && !closeDrawerBtn.dataset.listenerAdded) {
                closeDrawerBtn.addEventListener('click', this.closeCart.bind(this));
                closeDrawerBtn.dataset.listenerAdded = 'true';
            }

            this.productRemove.forEach((el) => {
                if (el.dataset.listenerAdded) return;

                el.addEventListener('click', (e) => {
                    this.removeProduct(e.currentTarget.dataset.line);
                });

                el.dataset.listenerAdded = 'true';
            });

            this.productQty.forEach((el) => {
                if (el.dataset.listenerAdded) return;

                el.addEventListener('click', (e) => {
                    this.changeCount(
                        e.currentTarget.dataset.line,
                        e.currentTarget.dataset.quantity
                    );
                });

                el.dataset.listenerAdded = 'true';
            });
        }

        openCart() {
            this.classList.add('active');
        }

        closeCart() {
            this.classList.remove('active');
        }

        updateCart() {
            if (this.isUpdating) return;

            this.isUpdating = true;

            fetch(window.theme.shopUrl + `?section_id=${this.dataset.sectionid}`)
                .then((res) => res.text())
                .then((data) => {
                    const html = new DOMParser().parseFromString(data, 'text/html');

                    const currentContainer = this.querySelector('.cart_container');
                    const newContainer = html.querySelector('.cart_container');
            

                    if (!currentContainer || !newContainer) return;
                    console.log(currentContainer)
                    currentContainer.querySelectorAll('lb-upsell-widget').forEach((el) => el.remove());
                    console.log(currentContainer)
                    currentContainer.innerHTML = newContainer.innerHTML;

                    const count = html.querySelector('.cart_totals-title')?.dataset.item_count;
                    const cartQuantity = document.querySelector('.cart-quantity');

                    if (count !== undefined && cartQuantity) {
                        cartQuantity.innerHTML = count;
                    }

                    this.initCart();
                })
                .catch((error) => {
                    console.error('Error', error);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.isUpdating = false;
                    }, 300);
                });
        }

        removeProduct(id) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    line: id,
                    quantity: 0,
                }),
            };

            fetch(window.theme.shopUrl + '/cart/change.js', requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        changeCount(id, quantity) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    line: id,
                    quantity: quantity,
                }),
            };

            fetch(window.theme.shopUrl + '/cart/change.js', requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    });
}

if (!window.__cartSyncPatched) {
    window.__cartSyncPatched = true;

    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
        const response = await originalFetch.apply(this, args);

        try {
            const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

            if (
                response.ok &&
                url &&
                (
                    url.includes('/cart/add.js') ||
                    url.includes('/cart/change.js') ||
                    url.includes('/cart/update.js')
                )
            ) {
                PubSub.publish(PubSub.EVENTS.cartUpdated);
            }
        } catch (error) {
            console.error('Cart sync error:', error);
        }

        return response;
    };
}